import React from "react";
import {
  H5,
  Menu as BPMenu,
  MenuItem as BPMenuItem,
  Popover,
  Position,
} from "@blueprintjs/core";
import { RbnBtn } from "./AgTable/ribbon";
import * as COLORS from "../styles/colors";
import { useMe, useMeData } from "../hooks/useMe";
import "styled-components/macro";
import { useBoolean } from "../helpers/useBoolean";
import { useStoreActions } from "../hooks/ep";
import {
  useAppMode,
  useAvailableAppModes,
  useAvailableItinModes,
  useItinMode,
  useToggleAppMode,
  useToggleItinMode,
} from "../store/model-misc"; // DO NOT REMOVE. Necessary for using the css={`...`} prop

export function UserSettings() {
  const { loading } = useMe();
  const meData = useMeData();

  if (loading || !meData) return <span>{""}</span>;
  else return <UserSettingsInner meData={meData} />;
}

function UserSettingsInner({ meData }) {
  const handleLogout = useStoreActions((a) => a.firebase.logout);

  // noinspection JSUnresolvedVariable
  const greeting = "Hi, " + meData.first_name + "!";

  const menu = (
    <BPMenu large className="bp3-dark">
      <div
        css={`
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          padding: 16px 0;
        `}
      >
        <H5
          css={`
            padding: 0 !important;
            margin: 0 !important;
          `}
        >
          {greeting}
        </H5>
      </div>
      <AppModeMenuItem />
      <ItinModeMenuItem />
      <BPMenuItem
        data-testid="logout_button"
        css={`
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
        `}
        intent="primary"
        icon="power"
        text="Logout"
        onClick={handleLogout}
      />
    </BPMenu>
  );
  const isOpen = useBoolean(false);
  return (
    <Popover
      content={menu}
      position={Position.BOTTOM}
      isOpen={isOpen.value}
      onClose={isOpen.setFalse}
    >
      <RbnBtn
        dataTestId="account_button"
        ghost={false}
        type={"primary"}
        size="large"
        icon="user"
        tooltipDisabled={isOpen.value}
        tooltipPlacement="bottom"
        title="Settings"
        hoverColor={COLORS.primary}
        onClick={isOpen.setTrue}
      />
    </Popover>
  );
}

function AppModeMenuItem() {
  const appMode = useAppMode();
  const availableAppModes = useAvailableAppModes();
  const toggleAppMode = useToggleAppMode();
  if (!availableAppModes) {
    return null;
  } else if (availableAppModes.length === 1) {
    return null;
  } else {
    return (
      <BPMenuItem
        data-testid="toggle_appmode_button"
        css={`
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
        `}
        intent="primary"
        icon="swap-horizontal"
        text="App Mode"
        label={appMode}
        onClick={toggleAppMode}
      />
    );
  }
}

function ItinModeMenuItem() {
  const itinMode = useItinMode();
  const availableItinModes = useAvailableItinModes();
  const toggleItinMode = useToggleItinMode();
  if (!availableItinModes) {
    return null;
  } else if (availableItinModes.length === 1) {
    return null;
  } else {
    return (
      <BPMenuItem
        data-testid="toggle_itinmode_button"
        css={`
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
        `}
        intent="primary"
        icon="swap-horizontal"
        text="Itin Mode"
        label={itinMode}
        onClick={toggleItinMode}
      />
    );
  }
}
